import {
    useGetAdProtocolIdQuery,
    useGetAdsamlConfigQuery,
    useGetIntegrationStatusByIdQuery,
} from '~/hasura/__generated__';
import { useTranslation } from 'react-i18next';
import { MicrosoftLogo } from '../svg/logos/microsoft/logo';
import './microsoft.css';

export default function LoginMicrosoft() {
    const { t } = useTranslation();

    const ADIntegrationID = 16;
    const SAMLProtocolID = 2;
    const { data: ADIntegrationData } = useGetIntegrationStatusByIdQuery({
        variables: { id: { _eq: ADIntegrationID } },
    });
    const { data: ADProtocolData } = useGetAdProtocolIdQuery();
    const { data: SAMLConfigData } = useGetAdsamlConfigQuery();

    const handleSubmitMicrosoft = () => {
        if (
            SAMLConfigData?.integracoes_ad_saml_parametrizacao[0]
                .url_encaminhamento != null
        ) {
            window.location.href =
                SAMLConfigData?.integracoes_ad_saml_parametrizacao[0].url_encaminhamento;
        }
    };

    return (
        <>
            {ADIntegrationData?.navia_integracoes[0].activo === true &&
                ADProtocolData?.integracoes_ad_parametrizacao[0]
                    .id_protocolo === SAMLProtocolID &&
                SAMLConfigData?.integracoes_ad_saml_parametrizacao[0]
                    .url_encaminhamento !== '' && (
                    <div
                        className="flex justify-center px-4 pb-4"
                        id="microsoftContainer"
                    >
                        <div className="w-full">
                            <div data-divider="thin" className="divider">
                                <span className="text-center text-sm font-normal text-gray-400">
                                    {' '}
                                    {t('common.or').toUpperCase()}{' '}
                                </span>
                            </div>
                            <button
                                className="w-full rounded-md border border-gray-50 bg-white shadow"
                                onClick={handleSubmitMicrosoft}
                            >
                                <div className="inline-flex p-2">
                                    <MicrosoftLogo />
                                    <span className="font-bold text-neutral-500">
                                        Microsoft
                                    </span>
                                </div>
                            </button>
                        </div>
                    </div>
                )}
        </>
    );
}
